import { formatCentsWithCurrency, formatCents } from '@/helpers/money.js';

export default function (value, withCurrency = true) {
  return withCurrency ? formatCentsWithCurrency(value) : formatCents(value);
};
